import { Route, Routes } from "react-router-dom";
import { Home, ViewProduct, Secciones} from "../Pages";
import { RouterAuth } from "../Auth/Router/RouterAuth";
import { useChekingAuth } from "../Auth";
import { RouterPayment } from "../Payment/Router/RouterPayment";
import { RoutesProfile } from "../Profile";

import { DetailCar } from "../Payment/View/DetailCar";
import { PublicRoutes } from "./PublicRoutes";
import { PrivateRoutes } from "./PrivateRoutes";

export const RoutesRoot = () => {
  const { logged } = useChekingAuth();

  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/seccion" element={<Secciones />} />
        <Route path="/seccion/:filters" element={<Secciones />} />
        <Route path="/seccion_search/:search" element={<Secciones />} />
        <Route path="/view-product/:id" element={<ViewProduct />} />

        {logged?.logged ? (
          <>
            <Route path="profile/*" element={<RoutesProfile />} />
            <Route path="payment/*" element={<RouterPayment />} />
          </>
        ) : (
          <Route path="/*" element={<RouterAuth />} />
        )}

        {/* <Route 
                    path='/*'
                    element={
                        <PublicRoutes>
                            <RouterAuth />
                        </PublicRoutes>
                    }
                />

                <Route
                    path='profile/*'
                    element={
                        <PrivateRoutes>
                            <RoutesProfile />
                        </PrivateRoutes>
                    }
                /> */}
      </Routes>
    </>
  );
};
